import { COHORT_SAMPLE_URL_POSTFIX } from '../../config/constants';
import { QueryType } from '../apollo/graphqlSchema';
import { isTransientAnalysisId } from '../../redux/utils/transientAnalysis';
import { queryTypeConfigLookup } from '../queryTypeLookup';

export const getQueryTypePagePath = (
  queryType: QueryType,
  analysisId?: string,
) => {
  const path = queryTypeConfigLookup[queryType].url;

  if (isTransientAnalysisId(analysisId) || !analysisId) {
    return path;
  }

  const result = `${path}/${analysisId}`;

  if (queryType === QueryType.CohortSample) {
    // In cohorts, we use a special search param that indicates
    // cohort analysis.
    return `${result}${COHORT_SAMPLE_URL_POSTFIX}`;
  }

  return result;
};

// Function doesn't work for cohort analysis
export const getCohortPagePath = (namedCohortId?: string) => {
  const path = queryTypeConfigLookup[QueryType.CohortSample].url;

  return `${path}${namedCohortId ? `/${namedCohortId}` : ''}`;
};
